export default __webpack_public_path__ + "static/media/tesla.251aa105.svg";